import { createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../../config/axios.config.ts'
import { IBusinessStatsResponse } from '../../features/seller/dashboard/Dashboard.tsx'
import { IAllTransactionsResponse } from '../../interfaces/business/seller/IAllTransactionsResponse.ts'
import { IBusinessOrdersResponse } from '../../interfaces/business/seller/IBusinessOrdersResponse.ts'
import { IBusinessNotificationResponse } from '../../interfaces/seller/IBusinessNotificationResponse.ts'
import { IBusinessOrdersDataResponse } from '../../interfaces/seller/IBusinessOrdersDataResponse.ts'
import { IBusinessProductCountResponse } from '../../interfaces/seller/IBusinessProductCountResponse.ts'
import { IBusinessTransactionsResponse } from '../../interfaces/seller/IBusinessTransactionsResponse.ts'
import { ITopBuyersResponse } from '../../interfaces/seller/ITopBuyersResponse.ts'
import { ITopProductsResponse } from '../../interfaces/seller/ITopProductsResponse.ts'
import { notificationSystem } from '../../utils/notificationSystem.ts'

export const getAllStatsAction = createAsyncThunk(
	'seller/getStats',
	async () => {
		try {
			const res = await axiosInstance.get('seller/sellerSaleStats')
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)

export const addProductAction = createAsyncThunk(
	'seller/addProduct',
	async (data: any) => {
		try {
			const res = await axiosInstance.post('seller/add-product', data)
			if (res.data.success) {
				notificationSystem(
					'product added successfully',
					`${res.data.product.productName} added`,
					false
				)
			} else {
				notificationSystem('Something went wrong', res.data.message, true)
			}
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)

export const getAllBusinessOrdersAction = createAsyncThunk(
	'seller/getAllBusinessOrders',
	async () => {
		try {
			const res = await axiosInstance.get<IBusinessOrdersResponse>(
				'business/business-orders'
			)
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)

export const getAllTransactionsAction = createAsyncThunk(
	'seller/getAllTransactions',
	async () => {
		try {
			const res = await axiosInstance.get<IAllTransactionsResponse>(
				'wallet/transactions'
			)
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)

export const getTopBuyersDataAction = createAsyncThunk(
	'seller/getTopBuyersData',
	async (id: string) => {
		try {
			const res = await axiosInstance.get<ITopBuyersResponse>(
				`business/top-buyers/${id}`
			)
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)

export const getTopRatedProductsDataAction = createAsyncThunk(
	'seller/getTopProductsData',
	async (id: string) => {
		try {
			const res = await axiosInstance.get<ITopProductsResponse>(
				`business/top-rated-products/${id}`
			)
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)

export const getBusinessTransactionsAction = createAsyncThunk(
	'seller/getBusinessTransactions',
	async (id: string) => {
		try {
			const res = await axiosInstance.get<IBusinessTransactionsResponse>(
				`business/transactions/${id}`
			)
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)

export const getOrdersByBusinessIdAction = createAsyncThunk(
	'seller/getOrdersByBusinessId',
	async (data: { businessId: string; status: string }) => {
		try {
			const res = await axiosInstance.get<IBusinessOrdersDataResponse>(
				`business/business-orders?status=${data.status}&businessId=${data.businessId}`
			)
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)

export const getBusinessNotificationsAction = createAsyncThunk(
	'seller/getBusinessNotifications',
	async (id: string) => {
		try {
			const res = await axiosInstance.get<IBusinessNotificationResponse>(
				`/business/notifications/${id}`
			)
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)

export const getBusinessProductCountAction = createAsyncThunk(
	'seller/getBusinessProductCount',
	async (data: { id: string; status: string }) => {
		try {
			const res = await axiosInstance.get<IBusinessProductCountResponse>(
				`/business/products-counts/${data.id}?status=${data.status}`
			)
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)

export const getBusinessStatsAction = createAsyncThunk(
	'seller/getBusinessStatsAction',
	async (id: string) => {
		try {
			const res = await axiosInstance.get<IBusinessStatsResponse>(
				`business/stats/${id}`
			)
			return res.data
		} catch (e) {
			console.log(e)
		}
	}
)
